/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Wpisz cokolwiek…',
  'fabric.editor.editorAssistiveLabel': 'Główny obszar zawartości. Zacznij pisać, aby wprowadzić tekst.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Otwórz okno dialogowe pomocy',
};
